import React, { ReactElement, memo, useState } from 'react';
import { SelectDropDown } from '../globalExports';
import { IconWithTooltip } from '../globalIcons';
import './SelectWithActionButton.css';

export interface ISelectWithActionButtonOption {
  id: string, value: string, label: string
}

interface SelectWithActionButtonProps {
  selectDropDownId: string,
  selectOptions: ISelectWithActionButtonOption[],
  buttonIconClassName: string,
  handleButtonClick: (selectedOption: ISelectWithActionButtonOption) => void,
  // Pass to control the selection from the parent, else the first option is selected by default
  selectValue?: ISelectWithActionButtonOption,
  handleSelectOptionChange?: (selectedOption: ISelectWithActionButtonOption) => void,
  buttonTooltipText?: string | ReactElement,
  isDisabled?: boolean,
  dropDownWidth?: number | string,
  containerClassName?: string,
}

const SelectWithActionButton = memo(function SelectWithActionButton(props: SelectWithActionButtonProps) {
  const {
    selectDropDownId,
    selectOptions,
    buttonIconClassName,
    handleButtonClick,
    selectValue,
    handleSelectOptionChange,
    buttonTooltipText,
    isDisabled,
    dropDownWidth,
    containerClassName,
  } = props;

  const [internalSelectedOption, setInternalSelectedOption] = useState<ISelectWithActionButtonOption | undefined>(selectOptions?.[0]);
  const selectedOption = selectValue ?? internalSelectedOption ?? selectOptions?.[0];

  return (
    // Stop events (incl. those bubbling from the portaled menu) reaching parents like a data grid, which would refocus the cell and close the menu
    <div
      className={'select__with__action__button ' + (containerClassName ?? '')}
      id={selectDropDownId + '-container'}
      onMouseDown={(event): void => event.stopPropagation()}
      onClick={(event): void => event.stopPropagation()}
      onKeyDown={(event): void => event.stopPropagation()}
    >
      <div className='select__with__action__button-dropdown-wrap' style={dropDownWidth ? { width: dropDownWidth } : undefined}>
        <SelectDropDown
          selectValue={selectedOption}
          selectOptions={selectOptions ?? []}
          handleSelectOptionChange={(val): void => {
            setInternalSelectedOption(val);
            handleSelectOptionChange?.(val);
          }}
          selectDropDownId={selectDropDownId}
          selectDropDownName={selectDropDownId}
          isDisabled={isDisabled}
          renderToBody={true}
        />
      </div>
      <div
        className={'select__with__action__button-btn' + (isDisabled ? ' disabled' : '')}
        id={selectDropDownId + '-btn'}
        onClick={(): void => {
          if (isDisabled || !selectedOption) return;
          handleButtonClick(selectedOption);
        }}
      >
        <IconWithTooltip iconClassName={buttonIconClassName} toolTipText={buttonTooltipText ?? ''} />
      </div>
    </div>
  );
})

export default SelectWithActionButton;
